import React from 'react'

const Time = ({ time, onChangeTime }) => {
    return (
        <div>Time : <input value={time} onChange={(e) => onChangeTime(e)} />minutes</div>
    )
}

export default Time